export default class EnvUtils {
  static env = process.env;

  /**
   * 判断环境
   * @param {'production'|'development'|'test'|'native'} env 环境名称
   * @param {boolean} isNodeEnv 是否是NODE_ENV
   * @returns {boolean}
   */
  static is(env, isNodeEnv = false) {
    if (isNodeEnv) return this.env.NODE_ENV === env;
    return this.get('ENV') === env;
  }

  /**
   * 获取环境变量
   * @param {string} name
   * @returns {string|number}
   */
  static get(name) {
    return this.env[`VUE_APP_${name}`] || this.env[name];
  }

  /**
   * 批量获取环境变量
   * @param {string[]} arr
   * @returns {(string|number)[]}
   */
  static getEnvs(arr) {
    return arr.map(name => this.get(name));
  }
}
